<template>
  <div id="goodsPurchaseDetail">
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicing/stockFlowList')" href="javascript:;">库存流水</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>调拨单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="invoicingHeadDown">
      <!-- 调拨单详情资料 -->
      <div class="goodsDetail">
        <div>调拨单详情</div>
        <div class="info">
          <div style="width: 20%">
            <div>单号：{{ list.orderCode }}</div>
            <div>出库仓库：{{ list.repositoryOutName }}</div>
            <div>入库仓库：{{ list.repositoryInName }}</div>
          </div>
          <div style="width: 20%">
            <div>业务日期：{{ list.createTime }}</div>
            <div>经手人：{{ list.handlerName }}</div>
            <div>制单人：{{ list.makerName }}</div>
          </div>
          <div style="width: 40%">
            <div>合计数量：{{ totalLength }}</div>
            <!-- <div>结算账户：现金</div>  -->
            <div>整单备注：{{ list.remarks == "" ? "无" : list.remarks }}</div>
          </div>
          <div style="width: 20%">
            <el-button
              type="primary"
              plain
              size="small"
              @click="voucherDialogVisible = true"
              >查看单据</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="
                (isDestroy == 0 && list.reviewStatus == 10) || list.reviewStatus == 11
              "
              @click="destroyRefundGoods"
              >作废</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isDestroy == 0 && list.reviewStatus == 20"
              @click="destroyCheck"
              >作废待审核</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isDestroy == 0 && list.reviewStatus == 10"
              @click="check"
              >审核</el-button
            >
            <el-button
              type="primary"
              size="small"
              v-if="isDestroy == 0 && list.reviewStatus == 11 && bool == false"
              @click="putinStock"
              >入库</el-button
            >
          </div>
        </div>
      </div>
      <div class="title">调拨商品</div>
      <!-- 表格 -->
      <div style="width: calc(100vw - 250px)">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            align="center"
            prop="goodsName"
            label="调拨商品"
            width="180"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="goodsNum"
            label="调拨数量"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="valueContent"
            label="规格"
          ></el-table-column>
          <el-table-column align="center" prop="goodsUnit" label="单位"></el-table-column>
          <el-table-column align="center" prop="inputNum" label="未入库量">
            <template slot-scope="scope">
              {{ scope.row.goodsNum - scope.row.inputNum }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <!-- <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-size="queryInfo.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                  ></el-pagination>
                </div> -->
      </div>
    </div>
    <!-- 单据 -->
    <el-dialog
      :visible.sync="voucherDialogVisible"
      width="16%"
      :before-close="handleVoucherClose"
    >
      <span>
        <div class="shopName">{{ shopInfo.shopName }}</div>
        <div class="voucherTitle shopName mb20">
          <span class="line"></span>
          <span>调拨单</span>
          <span class="lines"></span>
        </div>
        <div class="dottedLine"></div>
        <div class="dottedLine"></div>
        <div class="mt20 mb20">
          <div class="mb5">入库仓库：{{ list.repositoryInName }}</div>
          <div class="mb5">出库仓库：{{ list.repositoryOutName }}</div>
          <div class="mb5">经手人：{{ list.handlerName }}</div>
          <div class="mb5">单号：{{ list.orderCode }}</div>
          <div>日期：{{ list.businessTime }}</div>
          <div v-if="list.newestRuTime">
            最新入库时间：{{ list.newestRuTime.substr(0, 16) }}
          </div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mb5">商品名称/规格</div>
        <div class="flex-betweens">
          <div class="mb5" style="width: 23%; text-align: left">单价(元)</div>
          <div class="mb5" style="width: 25%; text-align: center">数量/单位</div>
          <div class="mb5" style="width: 23%; text-align: right">合计(元)</div>
        </div>
        <div class="flex-between" v-for="(item, index) in tableData" :key="index">
          <div class="mb5" style="width: 35%">
            {{ item.goodsName }}/{{ item.valueContent }}
          </div>
          <div class="flex-betweens mb20">
            <div style="width: 30%; text-align: left">{{ item.takePrice }}</div>
            <div style="width: 30%; text-align: center">
              {{ item.goodsNum }}/{{ item.goodsUnit }}
            </div>
            <div class="mb5" style="width: 30%; text-align: right">
              {{ (item.goodsNum * item.takePrice).toFixed(2) }}
            </div>
          </div>
        </div>
        <div class="dashedLine mb20"></div>
        <div class="mt20 mb20">
          <div>合计 {{ totalLength }}</div>
          <div>备注：{{ list.purchaseRemark ? list.purchaseRemark : "无" }}</div>
        </div>
        <div class="dottedLine"></div>
        <div class="dottedLine"></div>
        <div class="shopName mt20">谢谢惠顾！</div>
      </span>
    </el-dialog>
    <!-- 友情提示：该仓库未锁定，锁定后才能盘点 -->
    <div v-show="lockWarn" class="lockWarn">
      <div><img src="@/assets/icon/jjb.png" class="warn-img" /></div>
      <div class="mt22" style="color: #555; font-size: 18px">友情提示</div>
      <div class="mt22" style="color: #999; font-size: 16px; width: 300px">
        原单据中的仓库正在盘点，请解锁该仓库后再进行此操作！
      </div>
      <div style="margin-top: 20px">
        <el-button type="primary" plain @click="(lockWarn = false), (mask = false)"
          >取消</el-button
        >
        <el-button type="primary" @click="quickUnlock">快捷解锁</el-button>
      </div>
    </div>
    <div class="mask" v-show="mask"></div>
  </div>
</template>

<script>
import {
  singleGoodsChangeAll,
  destroyChangeGoods,
  enterGoodsChangeNotAll,
  checkCJGoodsChange,
  checkDesChangeGoods,
  lockRepository,
} from "../api";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      orderId: "",
      isDestroy: "",
      voucherDialogVisible: false,
      list: {
        orderCode: "",
        businessTime: "",
        handlerName: "",
        supplierName: "",
        repositoryName: "",
        otherFree: "",
        accountRefundPayable: "",
        refundRemark: "",
        settlementMethod: "",
        goodsName: "",
        totalTakePrice: "",
        takePrice: "",
      },
      totalLength: 0,
      arr: {},
      bool: "",
      lockWarn: false,
      mask: false,
    };
  },
  created() {
    // console.log(localStorage.getItem("orderId"))
    this.arr = JSON.parse(localStorage.getItem("detail") || "[]");
    console.log(this.arr);
    this.orderId = this.arr.orderId;
    this.isDestroy = this.arr.isDestroy;
    this.getSingleGoodsPurchaseList();
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 快捷解锁
    quickUnlock() {
      lockRepository({
        isManager: 1,
        repositoryId: this.list.repositoryId,
        isLock: 0,
      }).then((res) => {
        if (res.code == 1) {
          localStorage.setItem("inStockStyle", 4);
          this.$router.push("/invoicing/putGoodsInStock");
          this.$message.success("该仓库解锁成功");
        }
      });
      this.lockWarn = false;
      this.mask = false;
    },
    // 获取进货单详情列表
    getSingleGoodsPurchaseList() {
      singleGoodsChangeAll({
        isManager: 1,
        pageNo: 1,
        row: 9999,
        orderId: this.orderId,
      }).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.productJson;
          this.list = res.data;
          this.totalLength = this.tableData.length;
          var lists = [];
          lists.push(this.list);
          this.bool = lists.every((item, index, array) => {
            return item.inStorageStatus == 1;
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    // handleCurrentChange(newVal) {
    //     this.queryInfo.pageNum = newVal
    //     this.getSingleGoodsPurchaseList()
    // },
    // 作废
    destroyRefundGoods() {
      this.$prompt("确认作废吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          destroyChangeGoods({
            isManager: 1,
            orderId: this.orderId,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.$router.push("/invoicing/stockFlowList");
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 作废待审核
    destroyCheck() {
      this.$prompt("确认作废吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          checkDesChangeGoods({
            isManager: 1,
            orderId: this.orderId,
          }).then((res) => {
            if (res.code == 1) {
              this.getSingleGoodsPurchaseList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleVoucherClose() {
      this.voucherDialogVisible = false;
    },
    // 审核
    check() {
      checkCJGoodsChange({
        isManager: 1,
        orderId: this.orderId,
      }).then((res) => {
        if (res.code == 1) {
          this.getSingleGoodsPurchaseList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 入库
    putinStock() {
      console.log(this.list.isLock, "isLock");
      if (this.list.isLock == 1) {
        this.lockWarn = true;
        this.mask = true;
        return;
      }
      this.$router.push("/invoicing/putGoodsInStock");
      localStorage.setItem("inStockStyle", 4);
      // enterGoodsChangeNotAll({
      //     isManager: 1,
      //     orderId: this.orderId,
      //     productJson: JSON.stringify(this.tableData)
      // })
      // .then(res => {
      //     if (res.code == 1) {
      //         this.$message.success(res.msg);
      //         this.$router.push("/invoicing/stockFlowList")
      //     } else if (res.code == 2) {
      //         this.$message.error(res.msg);
      //         this.$router.push("/");
      //     } else {
      //         this.$message.error(res.msg);
      //     }
      // })
    },
  },
};
</script>

<style scoped>
.warn-img {
  width: 68px;
  height: 68px;
}
.lockWarn {
  width: 394px;
  height: 305px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  position: absolute;
  z-index: 3;
  top: 220px;
  left: 700px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
}
.mask {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(101, 101, 101, 0.6);
}
.mt22 {
  margin-top: 22px;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-betweens {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flex-between {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.flex-between:last-child {
  text-align: right;
}
.mb5 {
  margin-bottom: 5px;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.dottedLine {
  border: 1px dotted #ccc;
  margin-top: 5px;
}
.dashedLine {
  border: 1px dashed #ccc;
  margin-top: 5px;
}
.line {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  top: 85px;
}
.lines {
  width: 88px;
  height: 1px;
  background-color: #ccc;
  display: block;
  position: absolute;
  left: 195px;
  top: 85px;
}
.shopName {
  font-size: 18px;
  text-align: center;
  color: #000;
}
.goodName {
  width: 30%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.voucherTitle {
  padding-top: 15px;
  font-size: 18px;
}
.goodsDetail {
  width: calc(100vw - 280px);
  height: auto;
  background-color: #f8f8f8;
  padding: 20px;
}
.info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #737373;
}
.title {
  width: calc(100vw - 245px);
  height: 50px;
  line-height: 50px;
  margin: 20px auto;
  background-color: #f8f8f8;
  font-size: 15px;
  padding-left: 20px;
  box-sizing: border-box;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
  margin-top: 20px;
}
</style>
